// Copyright (c) 2018 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {deleteFile as deleteFileRepo} from '../../../product/shared/repositories';
import {getDefaultState as getFileDefaultState} from '@deere/cps-it.warranty-model-factory/lib/file';
export const deleteFile = fileToDelete =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await deleteFileRepo(fileToDelete);

            dispatch({
                property: 'file',
                type: actions.UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_CLAIMS_PROCESS,
                value: getFileDefaultState()
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/action-creators/delete-file.js